<template>
  <b-card
    class="document-review-card"
    :class="`bg-${bgVariant?bgVariant:'alert-bg'}`"
    no-body
  >
    <div
      class="card-content"
      :class="` before-bg-${variant}`"
    >
      <div class="d-flex justify-content-between align-items-center w-100">
        <div>
          <div class="text-container">
            <h6
              v-if="title"
              class="main-title"
            >
              {{ title }}
            </h6>
            <p
              v-if="description"
              class="description"
            >
              {{ description }}
            </p>
            <slot />
          </div>
        </div>
        <div v-if="btnText && btnText.length > 0">
          <T2Btn
            variant="fill"
            :color="variant"
            :to="btnTo"
            :target="btnTarget"
            :disabled="btnDisabled"
          >
            {{ btnText }}
          </T2Btn>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import T2Btn from '../components/T2Btn.vue'

export default {
  components: {
    T2Btn,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    variant: {
      type: String,
      default: 'warning',
    },
    bgVariant: {
      type: String,
      default: null,
    },
    btnText: {
      type: String,
      default: '',
    },
    btnTo: {
      type: [String, Object],
      default: '#',
    },
    btnTarget: {
      type: String,
      default: '_self',
      validator: value => ['_self', '_blank', '_parent', '_top'].includes(value),
    },
    btnDisabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.status::before {
      background: #ff0095;
    }
.document-review-card {
  border: none;
  border-radius: 8px;
  overflow: hidden;

  .card-content {
    display: flex;
    padding: 16px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 10px;
    border-radius: 8px;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 3px;
    }

    .text-container {
      display: flex;
      width: 100%;
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;

      .main-title {
        text-align: start;
        font-size: 16px;
        font-weight: 500;
        line-height: 1.5;
        margin-bottom: 0;
        align-self: stretch;
      }

      .description {
        text-align: justify;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.5;
        margin-bottom: 0;
        align-self: stretch;
      }
    }
  }
}

</style>
